import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "duplicate-pay-warning" }
const _hoisted_2 = { class: "dpw-table" }
const _hoisted_3 = { class: "dpw-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableComponent = _resolveComponent("tableComponent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": true,
    top: "27vh",
    width: "510px",
    "close-on-click-modal": false,
    onClose: _ctx.onCancel
  }, {
    title: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "dpw-title" }, "重复发薪提醒", -1)
    ])),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_tableComponent, {
            tableHead: _ctx.tableHead,
            tableData: _ctx.list,
            showPagination: false
          }, null, 8, ["tableHead", "tableData"])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dpw-tips" }, "以上人员近期已发过薪资，确定重复发薪？", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onConfirm
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("继续发薪")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}